import BaseFactory from 'services/sports/default/base-factory';
import PlayerSinglegame from './player-singlegame';
import Player from './player';
import Const from 'constants';

const classesMap = {
    [Const.GAME_TYPE_SINGLEGAME]: PlayerSinglegame,
};

class Factory extends BaseFactory {
    createObj(objectName, params) {
        const {sportConfig} = params;
        const gameType = sportConfig.getGameType();

        if (gameType in classesMap) {
            return new classesMap[gameType](params);
        }

        return new Player(params);
    }
}

export {Factory};
